import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { OpenFullEditorLink } from './OpenFullEditor';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorLinkComponent = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "100",
    children: /*#__PURE__*/_jsx(OpenFullEditorLink, {
      children: children
    })
  });
};
const DisabledInStudioMessage = ({
  anchor
}) => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "embeddedEditor.disableInMarketingStudio_jsx",
    elements: {
      Link: EditorLinkComponent
    },
    options: {
      anchor
    }
  });
};
export default DisabledInStudioMessage;